import cache from "../../apollo/cache";
import applicationStateQuery from "../queries/applicationStateQuery";

export default function applicationStateUpdate(data) {
  return cache.writeQuery({
    query: applicationStateQuery,
    data: {
      applicationState: data
    }
  })
}
